import { ReactComponent } from './number-5-xs.svg';
export const Number5IconXs = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=number-5-xs.js.map